
import { Component, Vue } from "vue-property-decorator";
import { handleFill, phoneNumberConvert, handleLogout } from "@/utils/util";
import { Getter } from 'vuex-class';
import { setAllowsBackGesture } from "@/utils/h5ToApp";
@Component({
  components: {
  }
})
export default class My extends Vue {
  @Getter companyId!: string
  @Getter isMultiStore!: boolean
  @Getter multiStoreList!: (string | number)[]
  // @Getter topSafetyHeight!: number
  @Getter info!: any
  @Getter logoUrl!: string
  handleFill = handleFill;
  phoneNumberConvert = phoneNumberConvert;
  storeCellList = [
    {
      title: "店铺信息",
      value: "",
      type: 1, // 1跳H5页面 2跳原生页面
      url: "/storeInfo",
      icon: "subscribe@2x.png",
    },
    {
      title: "常常鲜微店",
      value: "",
      type: 1,
      url: "/newCCXstore",
      icon: "subscribe-add@2x.png",
    },
   
  ];
  userCellList = [
    {
      title: "个人账号中心",
      value: "",
      type: 1,
      url: "/personAccountCenter",
      icon: "lock@2x.png",
    },
    {
      title: "隐私设置",
      value: "",
      type: 1,
      url: "/privacySet",
      icon: "safe@2x.png",
    },
    {
      title: "关于我们",
      value: "",
      type: 1,
      url: "/aboutUs",
      icon: "info-circle@2x.png",
    },
  ];

  // onSwitchCompany () {
  //   this.$router.push({
  //     path: '/chooseCompany',
  //     query: { setUp: '2' }
  //   });
  // }
  get getTitle() {
    if (this.isMultiStore) {
      return `多店总览（${this.multiStoreList.length}）`
    } else if (this.companyId) {
      return this.info.storeName
    } else {
      return '未选择店铺'
    }
  }

  onCellItemClick (item) {
    const { type, url } = item;
    if (url) {
      if (type == 1) {
        this.$router.push(url);
      } else if (type == 2) {
        this.$bridge.callHandler(url);
      }
    }
  }

  onLogOut () {
    this.$dialog
      .confirm({
        title: "温馨提示",
        message: "确认退出登录？",
      })
      .then(() => {
        // this.$bridge.callHandler("logout");
        handleLogout()
      });
  }

  // 是否禁用侧滑返回
  setAllowsBackGesture(isAllow: boolean) {
    setAllowsBackGesture(isAllow ? '1' : '0');
  }

  mounted() {
    this.setAllowsBackGesture(false);
  }
  beforeDestroy() {
    this.setAllowsBackGesture(true);
  }
}
